


























































































import {
  SfTabs,
  SfTable,
  SfButton,
  SfLoader,
  SfHeading,
  SfLink
} from '@storefront-ui/vue';
import {
  computed,
  defineComponent, onMounted, useAsync, useContext, useMeta, useRouter,
} from '@nuxtjs/composition-api';
import orderGetters from '~/modules/checkout/getters/orderGetters';
import {usePage, useApi, useFocusHelper} from '~/composables';
import OrderSummaryRow from '~/modules/customer/pages/MyAccount/OrderHistory/SingleOrder/OrderSummaryRow.vue';
import OrderInformationAddressColumn from '~/modules/customer/pages/MyAccount/OrderHistory/SingleOrder/OrderInformationAddressColumn.vue';
import {getInstance} from "~/helpers/hooks/getInstance";
import {PageCategory} from "~/types/PageCategory";
import {Header} from "~/types/homePage/HomepageCategories";
import {OrderDeliveryStatus, OrderDetails} from '~/types/orders/OrdersCategories'
import { getFormattedDate } from '~/utils/dateFormatter'
import DsbUserAddressDetails from "~/modules/customer/components/MyData/DsbUserAddressDetails.vue";
import DsbOrderShipments from "~/modules/customer/components/Orders/DsbOrderShipments.vue";
import {General} from "~/types/Page";
import DsbBreadcrumbs from '~/components/Breadcrumbs/DsbBreadcrumbs.vue'
import {customGetCustomerOrdersQuery} from "~/customQueries/GetCustomerOrders"

export default defineComponent({
  name: 'SingleOrder',
  components: {
    DsbOrderShipments,
    SfLink,
    SfHeading,
    SfButton,
    SfTable,
    SfTabs,
    SfLoader,
    OrderSummaryRow,
    OrderInformationAddressColumn,
    DsbUserAddressDetails,
    DsbBreadcrumbs
  },
  props: { orderId: { type: String, required: true } },
  setup(props) {
    const { pageTitle } = usePage()

    const vm = getInstance();
    pageTitle.value = vm.proxy.$i18n.t(`${PageCategory.HOMEPAGE}.${Header.ORDER_DETAILS}`).toString() + ' ' + props.orderId

    const {title} = useMeta()
    title.value = pageTitle.value

    const breadcrumbs = computed(() => [
      {
        text: vm.proxy.$i18n.t(`${PageCategory.HOMEPAGE}.${General.TITLE}`).toString(),
        link: "/"
      },
      {
        text: vm.proxy.$i18n.t(`${PageCategory.HOMEPAGE}.${Header.ORDERS}`).toString(),
        link: "/customer/order-history"
      },
      {
        text: pageTitle.value,
        link: ""
      }
    ])

    const context = useContext();
    const router = useRouter();

    const { query } = useApi();
    const getCustomCustomerOrdersQuery = customGetCustomerOrdersQuery
    const variables = { filter: { number: { eq: props.orderId } } };

    const asyncData = useAsync(async () => {
      // @ts-ignore
      const { data } = await query<CustomerOrdersQuery>(getCustomCustomerOrdersQuery, variables);
      const order = data.customer.orders.items[0] ?? null;

      if (!order) {
        router.push(context.localeRoute({ name: 'customer-order-history' }));

        return null;
      }

      return {
        order,
      };
    }, props.orderId);

    const ordersRoute = context.localeRoute({ name: 'customer-order-history' });

    function getOutStandingOrderItems(){
      const items = []

      for(const item of asyncData.value.order.items){
       if(item.quantity_shipped !== item.quantity_ordered) {
         items.push(item)
       }
      }

      return items
    }

    const outstandingOrderItems = computed(()=> getOutStandingOrderItems())

    onMounted(() => {
      const {focusOnFirstInteractiveElementInMain} = useFocusHelper()
      focusOnFirstInteractiveElementInMain()
    })

    return {
      ordersRoute,
      asyncData,
      getDate: orderGetters.getDate,
      PageCategory,
      OrderDetails,
      OrderDeliveryStatus,
      getFormattedDate,
      breadcrumbs,
      pageTitle,
      outstandingOrderItems,
      orderGetters
    };
  },
  head: {},
});
